import { HopsResponseError } from '@xingternal/hops';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Page, PageDetails } from '../../models/page';
import { fetchSliceOptions } from '../fetch-reducer';
import { EntityWithErrorState } from '..';
import { PublicTermsOverviewApiResponse } from '../../api/responses/api-response-types';

export type PublicPagesState = EntityWithErrorState<Page[]>;

export interface PublicPageDetailsState
  extends EntityWithErrorState<PageDetails> {
  notFound: boolean;
}

export interface PublicState {
  publicPages: PublicPagesState;
  publicPageDetails: PublicPageDetailsState;
}

export const pagesSlice = createSlice(
  fetchSliceOptions<PublicPagesState>({
    sliceName: 'publicPages',
    initialStatePayload: [],
    processPayload: (payload: PublicTermsOverviewApiResponse) =>
      payload.collection,
  })
);

const pageDetailsError = (
  state: PublicPageDetailsState,
  action: PayloadAction<any>
) => {
  const error = action.payload as HopsResponseError;
  if (error.response && (error.response as Response).status == 404) {
    state.notFound = true;
  }
  state.error = action.payload;
  state.loading = false;
};

const onLoadingPageDetails = (state: PublicPageDetailsState) => {
  state.notFound = false;
  state.loading = true;
  state.error = null;
};

export const pageDetailsSlice = createSlice(
  fetchSliceOptions<PublicPageDetailsState>({
    sliceName: 'pageDetails',
    initialStatePayload: null,
    onError: pageDetailsError,
    onLoading: onLoadingPageDetails,
  })
);
